export function formatUSD(value, digits = 2) {
  if (value === null || value === undefined || value === '') return '$0.00'

  const num = Number(value)

  if (isNaN(num)) return '$0.00'

  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
}
  